__turbopack_context__.v({
  "buttonsContainer": "styles-module-scss-module__lIY0la__buttonsContainer",
  "headerLink": "styles-module-scss-module__lIY0la__headerLink",
});
